<template>
  <v-app class="max primary" :class="tablet ? 'tablet' : ''">
    <v-content class="hidden-xs-only max primary">
      <div v-if="deving == true" class="max">
        <coming-soon @bypassCs="bypassCs()" @pp="pp = true" @tc="tc = true"/>
      </div>
      <div class="max primary" v-else>
        <strat-nav @closeMenu="navSelect" @previewRoute="previewRoute" @homeSection="resetHome()"/>
        <div class="strat-nav-btn primary overflow-hidden">
          <v-layout justify-end>
            <v-btn text rounded class="mr-3 dr-btn" color="amber" @click="reqDemoDialog = !reqDemoDialog">
              Request Demo
            </v-btn>
            <!-- <v-btn text rounded class="mr-3">
              <i class="las la-user-circle white--text" style="font-size: 34px;"></i>
            </v-btn> -->
            <v-btn text rounded class="" @mouseenter="openNav()"  @click="toggleNav()">
              <i class="nav-bars las la-bars" style="font-size: 34px;" v-if="navMenu == false"></i>
              <i class="las la-times tertiary--text" style="font-size: 34px;" v-else></i>
            </v-btn>
          </v-layout>
        </div>
        <div class="mca white" :class="navMenu ? 'opened' : ''" @click="closeMenu()">
          <div class="content-window">
            <div class="max" v-if="hoverRoute != null">
              <home v-if="hoverRoute == 'home'" />
              <overview v-if="hoverRoute == 'overview'" />
              <inv-relations v-if="hoverRoute == 'investor_relations'" />
            </div>
            <router-view v-else></router-view>
          </div>
        </div>
      </div>
      <v-dialog persistent width="74%" v-model="reqDemoDialog">
        <v-card flat class="pa-8 overflow-hidden">
          <demo-req @killReqDialog="killReqDialog()" />
        </v-card>
      </v-dialog>
      <v-dialog width="65%" v-model="pp">
        <v-card class="pa-10">
          <privacy-policy />
        </v-card>
      </v-dialog>
      <v-dialog width="65%" v-model="tc">
          <v-card class="pa-10">
            <terms />
          </v-card>
      </v-dialog>
    </v-content>
    <v-content class="mobi hidden-sm-and-up max primary">
      <div class="max" v-if="deving">
        <coming-soon v-if="deving" @bypassCs="bypassCs()" @pp="pp = true" @tc="tc = true"/>
      </div>
      <div class="max" v-else>
        <mobi-nav @closeMenu="navSelect" @homeSection="resetHome()"/>
        <div class="strat-nav-btn primary pa-3 overflow-hidden">
          <v-layout justify-center>
            <v-btn text rounded class="" @click="toggleNav()">
              <i class="nav-bars las la-bars" style="font-size: 24px;" v-if="navMenu == false"></i>
              <i class="las la-times tertiary--text" style="font-size: 24px;" v-else></i>
            </v-btn>
          </v-layout>
        </div>
        <div class="mca white" :class="navMenu ? 'opened' : ''" @click="closeMenu()">
          <div class="content-window">
            <router-view />
          </div>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import comingSoon from '../src/views/coming-soon'
import privacyPolicy from './views/privacy-policy'
import terms from './views/terms'
import stratNav from './components/nav-menu'
import mobiNav from './components/mobi-nav'
//preview-routes
import home from './views/Home'
import overview from './views/overview'
import invRelations from './views/investor_relations'
import demoReq from './views/demo_request'

export default {
  name: 'App',

  components: {
    comingSoon,
    privacyPolicy,
    terms,
    stratNav,
    home,
    overview,
    invRelations,
    demoReq,
    mobiNav,
  },
  data: () => ({
    navMenu: false,
    navColor: 'transparent',
    navIconColor: 'teal',
    curRoute: '',
    hoverRoute: null,
    home: 0,
    tablet: false,
    deving: true,
    pp: false,
    tc: false,
    reqDemoDialog: false,
  }),
  mounted(){
    const a = window.innerWidth
    if(a <= 1024) {
      //const b = '80%'
      //document.body.style.zoom = b
      this.tablet = true
      //eslint-disable-next-line
      console.log('app.mounted -- get size < 1400 and zoomout to --'+ a+' -- tablet should be set to true with the class in the main div : '+this.tablet)
    } else if (a < 1400) {
      //this.tablet = true
      //const b = '90%'
      //document.body.style.zoom = b
      //eslint-disable-next-line
      console.log('app.mounted -- get size < 2000 and zoomout to --'+ a)
    }
  },
  methods: {
    bypassCs(){
      this.deving = false
    },
    openNav(){
      this.navMenu = true
    },
    navSelect(r) {
      this.curRoute = r
      this.navMenu = false
      //eslint-disable-next-line
      console.log('app.methods.navSelect -- ' +r)
    },
    closeNav(){
      this.navMenu = false
    },
    toggleNav(){
      this.navMenu = !this.navMenu
    },
    closeMenu() {
      if(this.navMenu  == true) {
        this.navMenu = false
      }
    },
     previewRoute(r){
      this.hoverRoute = r
    },
    resetHome(){
      this.home = 0
    },
    killReqDialog() {
      this.reqDemoDialog = false
    }
  }
};
</script>

<style lang="scss">
body > div {
    transform: translate3d(0,0,0);
    -webkit-transform: translate3d(0,0,0);
    -webkit-overflow-scrolling: touch;
  }

  .strat-logo {
    position: fixed;
    top: 7%;
    left: 3%;
    height: 40px;
    width: 40px;
    background-image: url('./assets/strat-dk-circle.png');
    background-size: cover;
    z-index: 8;
    transition: all .2s;

    .dk-logo {
      opacity: 1;
      transition: all .2s
    }

    .lt-logo {
      opacity: 0;
      transition: all .2s
    }

    .changed {
      transition-delay: .5s;
      
      .dk-logo {
        opacity: 0;
        transition: all .2s
      }

      .lt-logo {
        opacity: 1;
        transition: all .2s
    }
    }
  }

  .strat-nav-btn {
    position: fixed;
    padding: 48px;
    top: 0;
    right: 0;
    height: 150px;
    width: 24%;
    border-radius: 0 0 0 100px;
    z-index: 6;
    transition: all .78s;

    .nav-bars {
      color: white;
    }

    &:hover{
      .nav-bars {
        color: #2BCDC9
      }
    }
  }

  .nav-menu {
    position: fixed;
    height: 150px;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 2;
  }

  .mca {
    position: fixed;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;

    .content-window {
      position: absolute;
      height: 100vh;
      width: 100%;
      top: 0;
      left: 0;
      transition: all .52s;

      .content-inner {
        height: 100vh;
        transition: all .52s;
        overflow-y: scroll;
        overflow-x: hidden !important;
      }
    }

    &.opened {
      height: 70%;
      top: 30%;
      width: 90%;
      left: 5%;
      overflow: hidden;
      
    }
  }

  .tablet {
    .strat-logo {
      position: fixed;
      top: 7%;
      left: 3%;
      height: 40px;
      width: 40px;
      background-image: url('./assets/strat-dk-circle.png');
      background-size: cover;
      z-index: 8;
      transition: all .2s;

      .dk-logo {
        opacity: 1;
        transition: all .2s
      }

      .lt-logo {
        opacity: 0;
        transition: all .2s
      }

      .changed {
        transition-delay: .5s;
        
        .dk-logo {
          opacity: 0;
          transition: all .2s
        }

        .lt-logo {
          opacity: 1;
          transition: all .2s
      }
      }
    }

    .strat-nav-btn {
      position: fixed;
      padding: 32px;
      top: 0;
      right: 0;
      height: 100px;
      width: 38%;
      border-radius: 0 0 0 100px;
      z-index: 6;
      transition: all .78s;

      .dr-btn {
        font-size: 12px;
      }

      .nav-bars {
        color: white;
      }

      &:hover{
        .nav-bars {
          color: #2BCDC9
        }
      }
    }

    /* .nav-menu {
      position: fixed;
      height: 100px;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 2;
    } */

    .mca {
      position: fixed;
      height: 100vh;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 3;

      .content-window {
        position: absolute;
        height: 100vh;
        width: 100%;
        top: 0;
        left: 0;
        transition: all .52s;

        .content-inner {
          height: 100vh;
          transition: all .52s;
          overflow-y: scroll;
          overflow-x: hidden !important;
        }
      }

      &.opened {
        height: 70%;
        top: 30%;
        width: 90%;
        left: 5%;
        overflow: hidden;
        
      }
    }
  }

  .mobi {
    .strat-nav-btn {
      position: fixed;
      top: 0;
      right: 0;
      height: 70px;
      width: 70px;
      border-radius: 0 0 0 40px;
      z-index: 6;
      transition: all .78s;

      .nav-bars {
        color: white;
      }
    }

    .nav-menu {
      position: fixed;
      height: 150px;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 2;
    }
    .mca {
      position: fixed;
      height: 100vh;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 1;

      .content-window {
        position: absolute;
        height: 100vh;
        width: 100%;
        top: 0;
        left: 0;
        transition: all .52s;
        overflow-x: hidden;

        .content-inner {
          height: 100vh;
          transition: all .52s;
          overflow-y: scroll;
        }
      }

      &.opened {
        height: 10%;
        top: 90%;
        width: 90%;
        left: 5%;
        overflow: hidden;
        
      }
    }
  }
</style>
